import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { whiteboardsService } from '../api/whiteboards.service';
import { WHITEBOARD_KEYS } from './queryKeys';

/**
 * Lists the whiteboards of a board.
 *
 * @remarks
 * 30 s staleTime rather than the usual 2 min because `activeEditorCount` is live data —
 * a longer window would show a stale "nobody is here" next to a whiteboard being edited.
 */
export function useWhiteboards(boardId: string) {
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId) ?? '';

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: WHITEBOARD_KEYS.byBoard(activeOrganizationId, boardId),
    queryFn: ({ signal }) => whiteboardsService.getByBoard(boardId, signal).then((r) => r.data),
    staleTime: 30_000,
    enabled: !!activeOrganizationId && !!boardId,
  });

  return {
    whiteboards: data ?? [],
    isLoading,
    isError,
    refetch,
  };
}
